import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const capeSandbox = defineConnector({
  identifier: "capeSandbox",
  name: "CAPE Sandbox",
  tagLine: "Malware detonation and analysis",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: ({ url }) =>
    url ? `${url}/.*` : "https://cape\\.example\\.com/.*",
  auth: (app) =>
    headerAuth([
      {
        name: "Authorization",
        value: app.secret.accessToken,
        scheme: "Token",
      },
    ]),
  steps: [
    {
      title: "Create a DRF authorization token",
      items: [
        {
          kind: "markdown",
          content:
            "Follow the official docs at [https://raw.githubusercontent.com/kevoreilly/CAPEv2/master/docs/book/src/usage/api.rst](https://raw.githubusercontent.com/kevoreilly/CAPEv2/master/docs/book/src/usage/api.rst) to create a Django REST Framework authorization token for the CAPE Sandbox API. CAPE documents requests as `Authorization: Token <YOUR_TOKEN>`.",
        },
      ],
    },
    {
      title: "Enter your connection details",
      items: [
        {
          kind: "url",
          label: "CAPE Sandbox base URL",
          placeholder: "https://cape.example.com",
          required: true,
          target: { kind: "configuration", field: "url" },
        },
        {
          kind: "input",
          label: "Authorization token",
          required: true,
          target: {
            kind: "secrets",
            field: "accessToken",
          },
        },
        {
          kind: "test-url",
          label: "Test URL",
          placeholder: "https://cape.example.com/health",
          helperText:
            "Optional. Set this if you want testing to hit a specific endpoint instead of the default draft URL.",
          urlTarget: {
            kind: "configuration",
            field: "testUrl",
          },
          methodTarget: {
            kind: "configuration",
            field: "testMethod",
          },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ testUrl, testMethod, ...configuration }) => ({
      url: testUrl ?? (({ url }) => `${url}/apiv2/tasks/list/`)(configuration),
      method: testMethod === "POST" ? "POST" : "GET",
    }),
  },
});
